<ng-container *ngIf="isAuthorized; else notAuthorizedTmp">
  <div class="wrapper">
    <div
      class="d-flex justify-content-between align-items-center mb-5"
      *ngIf="accountService.account$ | async as account"
    >
      <div class="d-flex align-items-center email-wrapper">
        <div class="email tw:text-gray-70">{{ account.email }}</div>
      </div>
      <a cfButton variant="link" [class.pointer-none]="isPreview" (click)="logout()">
        {{ "reschedule_page.logout" | translate }}
        @if (!isPreview) {
          <svg cfIcon="log_out" class="tw:text-blue-50"></svg>
        }
      </a>
    </div>
    <header class="tw:!mb-0">
      <div class="tw:text-base tw:font-medium">
        {{ date | dateFormat: "cccc, LLLL d, yyyy" }}
      </div>
    </header>
    <section *ngFor="let date of events">
      <div class="card" *ngFor="let event of date.events" [class.active]="event.highlighted">
        <cf-text size="sm" weight="600" color="grey-70">
          {{ event.start | dateFormat: timeFormat : true }} -
          {{ event.end | dateFormat: timeFormat : true }}
        </cf-text>
        <cf-text weight="500" color="grey-70" class="mt-1">
          {{ event.name }}
        </cf-text>
      </div>
    </section>
  </div>
</ng-container>

<ng-template #notAuthorizedTmp>
  @if (!showLoginForm) {
    <section class="no-auth">
      <cf-text weight="500">
        <a cf-link [class.pointer-none]="isPreview" (click)="signUpRedirect()">
          {{ "booking.schedule-auth" | translate | translateCut: 0 }}
        </a>
        {{ "booking.schedule-auth" | translate | translateCut: 1 }}
        <a cf-link [class.pointer-none]="isPreview" (click)="showLoginForm = true">
          {{ "booking.schedule-auth" | translate | translateCut: 2 }}
        </a>
        <br />
        <span [innerHTML]="'booking.schedule-auth' | translate | translateCut: 3"></span>
      </cf-text>
    </section>
  } @else {
    <cf-booking-login></cf-booking-login>
  }
</ng-template>
